import { FC } from "react";
import cx from "classnames";
import {
  NetworkPortfolioManagementProjectTypeEnum,
  networkPortfolioManagementProjectTypeDisplayLabel,
} from "@app/network-portfolio-management/interfaces";

interface ProjectDescriptionLineProps {
  lineOfBusiness: string | null;
  projectType: NetworkPortfolioManagementProjectTypeEnum;
  /**
   * Distinct county count for the selected membership. `null` or `0` omits the segment.
   */
  countyCount?: number | null;
  /**
   * Total zip count for the selected membership, for zip adequacy projects.
   * `null` or `0` omits the segment.
   */
  zipCodeCount?: number | null;
  /**
   * Resolved template name (e.g. the Adequacy Template Name for Blended projects). Blank omits the segment.
   */
  templateName?: string | null;
  className?: string;
  testId: string;
}

export const ProjectDescriptionLine: FC<ProjectDescriptionLineProps> = ({
  lineOfBusiness,
  projectType,
  countyCount,
  zipCodeCount,
  templateName,
  className,
  testId,
}) => {
  const projectTypeLabel = networkPortfolioManagementProjectTypeDisplayLabel[projectType];
  const countyCountText =
    !!countyCount ? `${countyCount.toLocaleString()} ${countyCount === 1 ? "County" : "Counties"}` : null;
  const zipCodeCountText =
    !!zipCodeCount ? `${zipCodeCount.toLocaleString()} ${zipCodeCount === 1 ? "Zip Code" : "Zip Codes"}` : null;

  if (!lineOfBusiness && !projectTypeLabel && !countyCountText && !zipCodeCountText && !templateName) return null;

  return (
    <div className={cx("network-portfolio-management-description-line", className)} data-testid={testId}>
      {lineOfBusiness}
      {lineOfBusiness && projectTypeLabel && (
        <span className="network-portfolio-management-description-line__separator" aria-hidden="true">·</span>
      )}
      {projectTypeLabel}
      {countyCountText && (lineOfBusiness || projectTypeLabel) && (
        <span className="network-portfolio-management-description-line__separator" aria-hidden="true">·</span>
      )}
      {countyCountText}
      {zipCodeCountText && (lineOfBusiness || projectTypeLabel || countyCountText) && (
        <span className="network-portfolio-management-description-line__separator" aria-hidden="true">·</span>
      )}
      {zipCodeCountText}
      {templateName && (lineOfBusiness || projectTypeLabel || countyCountText || zipCodeCountText) && (
        <span className="network-portfolio-management-description-line__separator" aria-hidden="true">·</span>
      )}
      {templateName}
    </div>
  );
};
